import inspectionApi from '@Apis/inspection.api';
import type { DefectCode } from '@Types/utils.types';
import type { InspectionStandard } from '@Types/inspections.types';

export const defectCodeKeys = {
	all: ['defectCodes'] as const,
	list: (standard: InspectionStandard) =>
		[...defectCodeKeys.all, 'list', standard] as const,
};

export const defectCodesQuery = (
	standard: InspectionStandard,
	enabled: boolean = true,
) => ({
	queryKey: defectCodeKeys.list(standard),
	queryFn: async () => {
		const { data } = await inspectionApi.get<DefectCode[]>(
			`/codes/${standard}`,
		);
		return data;
	},
	enabled: !!standard && enabled,
});
